module.exports = __webpack_public_path__ + "img/student_bg@3x.e3cf3d61.png";